import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { configureAmplify } from './lib/amplify-config';
import { queryClient } from './lib/queryClient';
import { ToastProvider } from './components/ToastProvider';
import { ThemeProvider } from './state/ThemePreference';
import App from './App';
import './index.css';

// Before anything renders, so the first token read has a configured client.
configureAmplify();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root was not found in index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
